module.exports = __webpack_public_path__ + "img/no-cctv.3998be3e.png";